export default {
  palette: {
    primary: '#f50d87',
    primary10: '#FEE7F3',
  },
};
